import { isNativeAndroid, isNativeIOS } from './utils'

import { Platform } from '@enums'

export const getPlatform = (): string => {
  return isNativeIOS()
    ? Platform.IOS
    : isNativeAndroid()
    ? Platform.Android
    : Platform.Web
}
